<template>
  <div class = "modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Crear una nueva pestaña</p>
    </header>

    <section class="modal-card-body">
      <div class="forms-container">
        <b-field label="Nombre de la pestaña">
          <b-input type="text" v-model="filename" id="nameField" placeholder="por ejemplo: acciones"  ref="nameField" required> </b-input>
        </b-field>
      </div>
    </section>

    <footer class="modal-card-foot">
      <a class="btn" v-on:click="$parent.close()">Cancelar</a>
      <a class="btn btn-bg-colored" v-on:click="createFile">Crear pestaña</a>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'NewClassRoom',
  data: () => ({
    filename: null
  }),
  methods: {
    createFile () {
      if (this.$store.getters.getIsProjectOnDb) {
        this.$store.dispatch('createCodeFile', this.filename)
        this.$parent.close()
      } else {
        this.$store.dispatch('createProjectInDbSimple')
          .then((response) => {
            this.$store.dispatch('createCodeFile', this.filename)
              .then(() => {
                this.$parent.close()
                this.$router.replace('/editor/' + response.data.id + '/')
              })
          })
      }
    }
  },
  computed: {
  },
  created () {
  }
}
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Editor/EditorNewFile.vue